// Lead attribution for the enquiry forms. Records where a visit came from (UTM tags, click
// ids or the referrer) and writes it into the forms' hidden firstTouch / lastTouch fields so
// every enquiry email says which channel produced it.
//
// This visit's touch lives in sessionStorage. The first-ever touch is only kept across visits
// in localStorage once Cookiebot reports statistics consent; without it the first touch is
// simply this session's.

const SESSION_KEY = 'aec_touch_session';
const FIRST_KEY = 'aec_touch_first';

const searchEngines = /(^|\.)(google|bing|duckduckgo|yahoo|ecosia|qwant)\./i;
const socialSites = /(^|\.)(linkedin|facebook|instagram|twitter|x|youtube|t)\.(com|co)/i;

const read = (storage, key) => {
    try {
        return storage.getItem(key);
    } catch (error) {
        return null;
    }
};

const write = (storage, key, value) => {
    try {
        storage.setItem(key, value);
    } catch (error) {
        // Storage can be unavailable in private windows; attribution is best effort.
    }
};

const statisticsConsent = () => Boolean(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics);

// Describes how this page load was reached, or null when it is an internal navigation.
const describeArrival = () => {
    const params = new URLSearchParams(window.location.search);
    const utm = (name) => (params.get(`utm_${name}`) || '').trim();
    let referrerHost = '';

    try {
        referrerHost = document.referrer ? new URL(document.referrer).hostname : '';
    } catch (error) {
        referrerHost = '';
    }

    const internal = referrerHost && referrerHost.replace(/^www\./, '') === window.location.hostname.replace(/^www\./, '');
    let source = utm('source');
    let medium = utm('medium');

    if (!source && params.get('gclid')) {
        source = 'google';
        medium = 'cpc';
    } else if (!source && params.get('msclkid')) {
        source = 'bing';
        medium = 'cpc';
    }

    if (!source) {
        if (internal) {
            return null;
        }
        if (!referrerHost) {
            source = 'direct';
            medium = 'none';
        } else if (searchEngines.test(referrerHost)) {
            source = referrerHost.replace(/^www\./, '').split('.')[0];
            medium = 'organic';
        } else if (socialSites.test(referrerHost)) {
            source = referrerHost.replace(/^www\./, '');
            medium = 'social';
        } else {
            source = referrerHost.replace(/^www\./, '');
            medium = 'referral';
        }
    }

    const parts = [
        `source=${source}`,
        `medium=${medium || 'none'}`,
    ];
    if (utm('campaign')) {
        parts.push(`campaign=${utm('campaign')}`);
    }
    if (utm('content')) {
        parts.push(`content=${utm('content')}`);
    }
    if (utm('term')) {
        parts.push(`term=${utm('term')}`);
    }
    parts.push(`landing=${window.location.pathname}`);
    parts.push(`date=${new Date().toISOString().slice(0, 10)}`);

    return parts.join('; ');
};

// Last non-direct click: a typed URL or bookmark never replaces a known channel.
const arrival = describeArrival();
if (arrival && !(arrival.startsWith('source=direct;') && read(window.sessionStorage, SESSION_KEY))) {
    write(window.sessionStorage, SESSION_KEY, arrival);
}

const lastTouch = read(window.sessionStorage, SESSION_KEY) || '';
let firstTouch = read(window.localStorage, FIRST_KEY) || '';

const persistFirstTouch = () => {
    if (!firstTouch && lastTouch && statisticsConsent()) {
        firstTouch = lastTouch;
        write(window.localStorage, FIRST_KEY, firstTouch);
    }
};

persistFirstTouch();
window.addEventListener('CookiebotOnAccept', persistFirstTouch);

const fill = () => {
    document.querySelectorAll('input[name="fields[firstTouch]"]').forEach((input) => {
        input.value = firstTouch || lastTouch;
    });
    document.querySelectorAll('input[name="fields[lastTouch]"]').forEach((input) => {
        input.value = lastTouch;
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fill);
} else {
    fill();
}
// Formie re-renders forms after Ajax submissions and cache refreshes.
document.addEventListener('onFormieInit', fill);
document.addEventListener('onAfterFormieSubmit', () => window.setTimeout(fill, 0));
